document.addEventListener('DOMContentLoaded', function () {
  const html = document.documentElement;
  const modal = document.querySelector('#giftbox-quickadd');
  const listGiftbox = modal.querySelector('#list-giftbox .giftbox-popup-products-scroll');
  const quickAddButtons = modal.querySelectorAll('.gift-item--quickadd');
  let currentParent;
  let currentCart;

  const openModal = () => {
    modal.classList.add('modal--is-active');
    html.classList.add('modal-open');
    reloadGiftbox();
  };
  const closeModal = () => {
    modal.classList.remove('modal--is-active');
    html.classList.remove('modal-open');
  };

  document.addEventListener('click', function (e) {
    const el = e.target.closest('[data-popup="giftbox-quickadd"]');
    if (!el) return;
    currentParent = {
      key: el.dataset.key,
      variant_id: Number(el.dataset.variant_id),
      quantity: Number(el.dataset.quantity),
      properties: Object.fromEntries(JSON.parse(el.dataset.properties || '[]')),
      bundle_title_properties: el.dataset.bundle_title_properties
    };
    openModal();
  });
  modal.querySelector('.close-modal')?.addEventListener('click', closeModal);
  modal.addEventListener('click', (e) => {
    const content = modal.querySelector('.giftbox-quickadd-content');
    if (!content.contains(e.target)) {
      closeModal();
    }
  });

  if (quickAddButtons) {
    quickAddButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        addBundle(e.currentTarget);
      });
      window?.XD?.fetchInventorySingle(button.dataset.id);
    });
  }




  const addBundle = async (element) => {
    /* 1. Lấy cart & parent */
    if (
      !currentParent?.key ||
      !element?.dataset?.id || !element?.dataset?.title
    ) {
      closeModal();
      return;
    }

    listGiftbox.classList.add('loading-spinner');

    const parentRow = document.querySelector(`.cart__item[data-key="${currentParent.key}"]`);
    if (parentRow) {
      parentRow.classList.add('loading-spinner');
    }

    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: currentParent.key, quantity: 0 })
    });

    const bundleId = '#' + Math.floor(1000 + Math.random() * 9000);

    /* 2. Properties cho parent */
    const newParentProperties = {
      ...currentParent.properties,
      [currentParent.bundle_title_properties]: element.dataset.title,
      _bundle_id: bundleId,
      _bundle_list: element?.dataset?.id
    };

    await new Promise(resolve => setTimeout(resolve, 2500)); // Hotfix: Lỗi App discount call API ajax update làm thay đổi key của product, cần chờ nó update xong

    /* 3. Add parent + child cùng lúc */
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          { // Hotfix add 1 product
            id: element.dataset.id,
            quantity: currentParent.quantity,
            properties: {
              _bundle_id: bundleId
            }
          },
          {
            id: currentParent.variant_id,
            quantity: currentParent.quantity,
            properties: newParentProperties
          }
        ]
      })
    })
    .then(res => res.json())
    .then(res => {
      if (res.status === 422) {
        alert(res.message || "Error")
      }

      return;
    });

    if (window.XD && window.XD.updateCartNoteFromBundles) {
      await window.XD.updateCartNoteFromBundles();
    }

    listGiftbox.classList.remove('loading-spinner');
    document.dispatchEvent(new Event('cart:build'));
    closeModal();

    if (window.DiscountCodeManagerInstance) {
      await window.DiscountCodeManagerInstance.updateCartDisplay();
    }

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  async function reloadGiftbox() {
    listGiftbox.classList.add('loading-spinner');

    const cartRes = await fetch('/cart.js');
    currentCart = await cartRes.json();

    for (const button of quickAddButtons) {
      const currentQtyAvailable = await window.XD.getVariantQuantityAvailable(button.dataset.id);
      const currentQty = window.XD.getVariantQuantity(currentCart, button.dataset.id);
      const maxQty = currentQtyAvailable - currentQty;
    
      if (currentParent.quantity > maxQty) {
        button.classList.add('hidden');
        button.closest('.gift-item')?.querySelector('.gift-item--status')?.classList.remove('hidden');
      }
    }

    listGiftbox.classList.remove('loading-spinner');
  }
});